import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import EmbedContent from '@spp/ui-embed-content';
import { themer } from '@spp/theme-provider';

// This is a hack to provide a wrapper element as this is not supported in web-sdk yet.
const EmbedWrapper = ({ url, subtype, theme, ...rest }) => {
    const isTippebanner = /^https:\/\/widget\.tippebannere\.no/.test(url);

    if (subtype === 'top-banner') {
        let disclaimer;
        if (isTippebanner) {
            disclaimer = (
                <span className={theme.tippebannerDisclaimer}>
                    <a href="#commercial-disclaimer">Hva er dette?</a>
                </span>
            );
        }

        const className = classnames(theme.topBanner, isTippebanner && theme.tippebanner);

        let embedContent = <EmbedContent {...rest} />;
        // add stretch (-16px) if not tippebanner
        if (!isTippebanner) {
            embedContent = <div className={theme.stretch}>{embedContent}</div>;
        }

        return (
            <div className={className}>
                {embedContent}
                {disclaimer}
            </div>
        );
    }

    if (isTippebanner) {
        return (
            <div className={theme['nt-widget-bottom']} id="commercial">
                <EmbedContent {...rest} scrolling="no" />
            </div>
        );
    }

    return <EmbedContent {...rest} />;
};

EmbedWrapper.propTypes = {
    url: PropTypes.string,
    subtype: PropTypes.string,
    theme: PropTypes.shape({
        url: PropTypes.string,
    }),
};

EmbedWrapper.defaultProps = {
    url: '',
    subtype: '',
    theme: {},
};

export default themer('@vg/ui-embed-wrapper')(EmbedWrapper);



/** WEBPACK FOOTER **
 ** ./src/local-components/article/EmbedWrapper.js
 **/